import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import useBodyClass from "../../hooks/useBodyClass";

function LoginPage() {
  useBodyClass();
  const navigate = useNavigate();
  const [localUsername, setLocalUsername] = useState("");
  const [password, setPassword] = useState("");
  const { isLoggedIn, setIsLoggedIn, setIsSuperuser, setUsername } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/", { replace: true });
    }
  }, [isLoggedIn, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!localUsername || !password) {
      setError("ユーザー名とパスワードを入力してください");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/login/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          username: localUsername,
          password: password,
        }),
      });
      if (!response.ok) {
        setIsLoggedIn(false);
        setIsSuperuser(false);
        localStorage.setItem("isLoggedIn", false);
        localStorage.setItem("isSuperuser", false);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      setIsLoggedIn(true);
      setUsername(localUsername);

      if (data.is_superuser) {
        setIsSuperuser(true);
      }

      localStorage.setItem("isLoggedIn", true);
      localStorage.setItem("isSuperuser", data.is_superuser);
      localStorage.setItem("username", localUsername);
      navigate("/");
    } catch (error) {
      setIsLoggedIn(false);
      setIsSuperuser(false);
      localStorage.setItem("isLoggedIn", false);
      localStorage.setItem("isSuperuser", false);
      console.error("ログイン中にエラーが発生しました:", error);
      setError("ユーザー名またはパスワードが違います。");
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h1>RUDO FACTORY</h1>
        <h2>Admin Login</h2>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={localUsername}
              onChange={(e) => setLocalUsername(e.target.value)}
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;
